export default "__VITE_ASSET__D4VM_ZsN__"